import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=07018b74&scoped=true&"
import script from "./Actions.vue?vue&type=script&lang=js&"
export * from "./Actions.vue?vue&type=script&lang=js&"
import style0 from "./Actions.vue?vue&type=style&index=0&id=07018b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07018b74",
  null
  
)

export default component.exports